export default {
    CURRENT_USER(state, user) {
        state.currentUser = user;
    },

    CURRENT_ORGANIZATION(state, {_id, name, shortName, color, theme, cover, title, description, welcomeTitle, showBackgroundText}) {
        if (_id) {
            state.currentOrganization._id = _id;
        }
        if (name) {
            state.currentOrganization.name = name;
        }
        if (shortName) {
            state.currentOrganization.shortName = shortName;
        }
        if (color) {
            state.currentOrganization.color = color;
        }
        if (theme) {
            state.currentOrganization.theme = theme;
        }
        if (cover) {
            state.currentOrganization.cover = cover;
        }
        if (title) {
            state.currentOrganization.title = title;
        }
        if (description) {
            state.currentOrganization.description = description;
        }
        if (welcomeTitle) {
            state.currentOrganization.welcomeTitle = welcomeTitle;
        }
        if (showBackgroundText) {
            state.currentOrganization.showBackgroundText = showBackgroundText;
        }
    },

    SET_CURRENT_ORGANIZATION_DEFAULTS(state) {
        state.currentOrganization = {
            _id: '',
            name: '',
            shortName: '',
            color: '',
            theme: '',
            cover: null,
            title: null,
            description: null,
            contactLocation: null,
            contactEmail: null,
            additionalInformation: '',
            welcomeTitle: '',
            showBackgroundText: false
        };
    }
}
